module.exports = __webpack_public_path__ + "img/964412116.603f0ff0.jpg";